import {getCasesByUserLineId} from "../api/getCasesByUserLineId";
import {useCallback, useEffect, useRef, useState} from "react";
import {ICase} from "../../../types/Case";

type UseCasesByUserLineIdParams = {
  token: string
}

export const useCasesByUserLineId = ({ token }: UseCasesByUserLineIdParams) => {
  const [cases, setCases] = useState<ICase[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>('');

  const hasLoadedOnceRef = useRef(false);

  const fetchCases = useCallback(async () => {
    if (!hasLoadedOnceRef.current) {
      setLoading(true);
    }
    setError('');

    try {
      const data = await getCasesByUserLineId({ token });
      setCases(data);
      hasLoadedOnceRef.current = true;
    } catch (error) {
      setError(error?.message || 'error fetching cases');
    } finally {
      setLoading(false);
    }
  }, [token])

  useEffect(() => {
    if (!token) return;
    fetchCases();
  }, [token, fetchCases])

  return { cases, loading, error, refetch: fetchCases };
}
